module.exports = __webpack_public_path__ + "static/sacramento-bd2d32d9a75997156c63841c6bb69b52.png";